module.exports = __webpack_public_path__ + "img/cond.ba235a31.png";